/**
 * Left sidebar behaviour — lean replacement for the Hyper theme's layout.js
 * (LeftSidebar + LayoutThemeApp + the sidebar bits of RightBar) and the
 * preloader fade from hyper.js's App.init. (DDT-3772 — drop Hyper JS.)
 *
 * Only the behaviours the app actually uses are kept:
 *   - metisMenu on `.side-nav` (collapsible menu)
 *   - active-link highlighting from the current URL
 *   - `.button-menu-mobile` toggles the off-canvas sidebar (`body.sidebar-enable`)
 *   - responsive: tablet (769–1279px) gets the condensed (icon) sidebar; desktop
 *     gets the full sidebar (mobile is off-canvas via CSS) — design-system breakpoints
 *   - sidebar theme (`data-leftbar-theme`) from `body[data-layout-config]`
 *   - click outside the menu closes the off-canvas sidebar
 *   - preloader / loading fade-out
 *
 * Dropped as dead in this app: Topbar (navbar-toggle/top-search/topnav-menu),
 * RightBar panel, layout boxed/scrollable/dark-mode config UI.
 */
import $ from 'jquery';
import 'metismenu';

(function () {
    // app.js and the messages entry both load on the messages page; guard so we
    // bind the delegated handlers and run init only once per page.
    if (window.__ddSidebarInit) return;
    window.__ddSidebarInit = true;

    const $body = $('body');

    function getConfig() {
        const cfg = $body.data('layoutConfig') || {};
        return {
            theme: cfg.leftSideBarTheme || 'default',
            isCondensed: !!cfg.leftSidebarCondensed,
            isScrollable: !!cfg.leftSidebarScrollable,
        };
    }

    function applyTheme(theme) {
        $body.removeAttr('data-leftbar-theme');
        if (theme === 'light' || theme === 'dark') {
            $body.attr('data-leftbar-theme', theme);
        }
    }

    function setCondensed(on) {
        if (on) $body.attr('data-leftbar-compact-mode', 'condensed');
        else $body.removeAttr('data-leftbar-compact-mode');
    }

    // Tablet (769–1279px): condensed (icon) sidebar. Desktop (>=1280): full.
    // Mobile (<=768): off-canvas via CSS. (DDT-3772 design-system breakpoints.)
    function adjustLayout() {
        const w = $(window).width();
        if (w >= 769 && w <= 1279) {
            setCondensed(true);
        } else {
            const cfg = getConfig();
            if (!cfg.isCondensed && !cfg.isScrollable) setCondensed(false);
        }
    }

    // Highlight the menu entry for the current page and open its metisMenu parents.
    function activateMenu() {
        const pageUrl = window.location.href.split(/[?#]/)[0];
        $('.side-nav a').each(function () {
            if (this.href !== pageUrl) return;
            const $link = $(this);
            $link.addClass('active');
            // Walk up the metisMenu structure: <li> ancestors get `mm-active`,
            // <ul> ancestors get `mm-show`, and each submenu's toggle <a> (the
            // element just before the <ul>) gets `active`.
            let $node = $link.parent();
            while ($node.length && !$node.is('body')) {
                if ($node.is('li')) $node.addClass('mm-active');
                if ($node.is('ul')) {
                    $node.addClass('mm-show');
                    $node.prev('a').addClass('active');
                }
                $node = $node.parent();
            }
        });
    }

    function init() {
        const cfg = getConfig();
        applyTheme(cfg.theme);

        // collapsible menu + active state
        $('.side-nav').metisMenu();
        activateMenu();

        // responsive condensed/full
        adjustLayout();
        $(window).on('resize', adjustLayout);

        // off-canvas toggle (mobile)
        $(document).on('click', '.button-menu-mobile', function (e) {
            e.preventDefault();
            $body.toggleClass('sidebar-enable');
        });

        // click outside the menu closes the off-canvas sidebar
        $(document).on('click', function (e) {
            const $t = $(e.target);
            if ($t.closest('.left-side-menu, .side-nav, .button-menu-mobile').length) return;
            $body.removeClass('sidebar-enable');
        });

        // preloader / anti-FOUC fade (app.js also strips `loading` as a safety net)
        $(window).on('load', function () {
            $('#status').fadeOut();
            $('#preloader').delay(350).fadeOut('slow');
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
